import { Reorder, motion } from "framer-motion";
import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Header, Icon, Label, Segment } from 'semantic-ui-react';
import { CreateSportsSeasonContext } from "./CreateSeason";
import WrapperVertCols from "../../../global/wrappers/WrapperVertCols";
import { useSportsFilters } from "../useHelpers/useSportsFilters";
import { useCreateSportsSeason } from "../useHelpers/useCreateSeasonal";

const SeasonSections = ({ }) => {

  // createSportsSeaonContext
  const createSportsSeaonContext = useContext(CreateSportsSeasonContext);
  const { createSportsSeason_handlers } = createSportsSeaonContext ?? {}

  const { getCurrent, ammendSeasonalItem } = useCreateSportsSeason()
  const { sportsSeason_selected, selectedItems } = getCurrent()

  const { seasonals, selectedSectionLevel } = sportsSeason_selected
  const { teams } = seasonals ?? {}
  const _sportSeasonTeams = teams ? _.cloneDeep(teams) : {}

  const { getLevelTeams } = useSportsFilters()

  const _buttonSize = 'tiny'
  const allowEdit = true

  const [currentLevelCounts, setCurrentLevelCounts] = useState()

  const { levelTeams, sectionCounts } = useMemo(() => {
    const { levelTeams: _levelTeams, sectionCounts: _sectionCounts } = getLevelTeams({ teams: _sportSeasonTeams })
    return { levelTeams: _levelTeams, sectionCounts: _sectionCounts }
  }, [])

  useEffect(() => {
    const _currentLevelCounts = {}
    _.forEach(sectionCounts, (sectionCount, key) => {
      if (sectionCount > 0) {
        _currentLevelCounts[key] = sectionCount
      }
    })
    setCurrentLevelCounts(_currentLevelCounts)
  }, [sectionCounts]);

  const handleSectionClick = (e, levelKey, sectionKey) => {
    e.stopPropagation()
    createSportsSeason_handlers.handleSelect_sectionLevel({ levelKey, sectionKey })
  }

  const handle_levelTeams = (lts) => createSportsSeason_handlers.handleAmmend_levelTeams(lts)

  const handleRemoveLevelTeams = (levelKey) => {
    _.forEach(_sportSeasonTeams, (team) => {
      if (team?.levels === levelKey) {
        _sportSeasonTeams[team._itemKey].levels = null
        _sportSeasonTeams[team._itemKey].sections = null
      }
    })
    ammendSeasonalItem({ key: 'teams', _sportSeasonTeams })
  }

  const handleRemoveSectionTeams = (levelKey, sectionKey) => {
    _.forEach(_sportSeasonTeams, (team) => {
      if (team?.levels === levelKey && team?.sections === sectionKey) {
        _sportSeasonTeams[team._itemKey].levels = null
        _sportSeasonTeams[team._itemKey].sections = null
      }
    })
    ammendSeasonalItem({ key: 'teams', _sportSeasonTeams })
  }

  const handleRemoveSectionTeam = (team) => {
    _sportSeasonTeams[team._itemKey].levels = null
    _sportSeasonTeams[team._itemKey].sections = null
    ammendSeasonalItem({ key: 'teams', _sportSeasonTeams })
  }

  const handleTeamSort = (tms, levelKey, sectionKey) => {
    const _teams = {}
    _.forEach(tms, (tm, index) => {
      _teams[tm._itemKey] = tm
      _teams[tm._itemKey].position = index
    })
    const _lts = _.cloneDeep(levelTeams)
    _lts[levelKey][sectionKey] = _teams
    handle_levelTeams(_lts)
  }

  const content_teams = (levelKey, sectionKey) => {

    const _teams = levelTeams?.[levelKey]?.[sectionKey];
    if (!_teams) return;


    let position = 0;

    const sortedTeams = _teams ? _.sortBy(_teams, [
      (team) => team.position ?? Infinity, // Use Infinity for teams without seed
      'name',                         // Fallback to name
    ]) : [];

    const _sectionTeams = _.map(sortedTeams, (team, teamIndex) => {
      let cn = "tournament-item";
      position++;
      if (team.temp) cn += " tmp";

      return (
        <Reorder.Item
          key={team._itemKey || team.name} // Ensure each item has a unique key
          value={team} // Required by Reorder.Item
          className='tournament-item'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <Label
            color={"blue"}
            size={_buttonSize}
            style={{ marginRight: "1em" }}
          >
            {position}
          </Label>
          {team.name}
          <div>
            <Icon
              name="delete"
              color="red"
              style={{ float: "right" }}
              onClick={() => handleRemoveSectionTeam(team)}
            />
          </div>

        </Reorder.Item>
      );
    });

    return (
      <Reorder.Group
        as="div"
        axis="y"
        values={sortedTeams} // Initial order of teams 
        onReorder={(newOrder) => handleTeamSort(newOrder, levelKey, sectionKey)}
        style={{ listStyle: 'none', padding: 0 }}
      >
        {_sectionTeams}
      </Reorder.Group>
    );
  };

  const lbl_d = (caption, value, color, float) => <Label size={_buttonSize} color={color} style={{ float: float ? float : 'right', marginLeft: '1em' }}>{caption} <Label.Detail>{value}</Label.Detail></Label>
  const lbl_i = (value) => <Label size={_buttonSize} color={'black'} style={{ float: 'right', marginLeft: '1em' }}>{value}</Label>
  const icon_l = (levelKey) => <Icon name='delete' color={'red'} style={{ float: 'right', marginLeft: '1em' }} onClick={() => handleRemoveLevelTeams(levelKey)}></Icon>
  const icon_s = (levelKey, sectionKey) => <Icon name='delete' color={'red'} style={{ float: 'right', marginLeft: '1em' }} onClick={() => handleRemoveSectionTeams(levelKey, sectionKey)}></Icon>

  const content_section = (levelKey, levelCount) => {
    return _.times(levelCount, (sectionIndex) => {
      const sectionKey = 'section' + (sectionIndex + 1)
      const _selected = selectedSectionLevel?.levelKey === levelKey && selectedSectionLevel?.sectionKey === sectionKey
      const cn = _selected ? 'season-section selected' : 'season-section'
      const _teams = levelTeams?.[levelKey]?.[sectionKey];
      const _count = _.size(_teams)
      return <div className={cn} >
        <Header as="h4" style={{ display: 'grid', gridTemplateColumns: '1fr auto auto' }} onClick={(e) => handleSectionClick(e, levelKey, sectionKey)}>
          <div>{_.startCase(sectionKey)}</div>
          {_count > 0 && <div>{icon_s(levelKey, sectionKey)}</div>}
          {lbl_i(_count)}
        </Header>
        <div className="season-section-teams">
          {content_teams(levelKey, sectionKey)}
        </div>
      </div>
    });
  }

  let cn = 'tournament-pools'
  if (!allowEdit) { cn += ' norm' }

  const content = () => {
    return currentLevelCounts && _.map(currentLevelCounts, (levelCount, levelKey) => (
      <div className='season-level' key={levelKey}>
        <Header as="h4" style={{ display: 'grid', gridTemplateColumns: '1fr auto auto' }}>
          <div>{_.startCase(levelKey)}</div>
          <div>{icon_l(levelKey)}</div>
          {lbl_i(levelCount)}
        </Header>
        <div>
          {content_section(levelKey, levelCount)}
        </div>
      </div>
    ))
  }

  const content_levels = () => <WrapperVertCols mvc={_.size(_.keys(currentLevelCounts))}>
    {content()}
  </WrapperVertCols>

  return (
    <div className={cn}>
      {content_levels()}
    </div>
  )
}

export default SeasonSections